var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailMax = function SvgMailMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3451",
    stroke: "#2E3451",
    strokeWidth: 0.5,
    d: "M26.39 7.533H9.275a2.945 2.945 0 0 0-2.942 2.942v4.252H3.508a.842.842 0 0 0 0 1.684h2.824v2.262H4.923a.842.842 0 0 0 0 1.685h1.409v1.1A2.946 2.946 0 0 0 9.274 24.4H26.39a2.946 2.946 0 0 0 2.942-2.942V10.475a2.946 2.946 0 0 0-2.942-2.942zM9.275 9.218H26.39c.299 0 .573.105.79.28l-8.177 6a2 2 0 0 1-2.344 0l-8.176-6c.216-.175.49-.28.79-.28zm18.374 12.24c0 .693-.564 1.257-1.257 1.257H9.274a1.258 1.258 0 0 1-1.257-1.257v-1.1h3.171a.842.842 0 1 0 0-1.685h-3.17v-7.429l7.646 5.611a3.665 3.665 0 0 0 2.17.703 3.66 3.66 0 0 0 2.168-.703l7.647-5.61v10.213z"
  })));
};
export default SvgMailMax;